import { setUser } from '@sentry/react';
import moment from 'moment';
import { getBaseInfo, getOrgByID } from '@/services/authorized';
import { permissionLeftDetail } from '@/utils';

enum permissionTypeProps {
  机构付费 = 1,
  个人付费 = 2,
  免费试用 = 3,
}
const AuthModel = {
  namespace: 'auth',
  state: {
    userInfoLoading: false,
    userInfo: undefined,
    errorInfo: null,
    magicInfo: null,
  },

  effects: {
    // 获取数据
    *setData({ payload }, { put }) {
      yield put({ type: 'updateState', res: { ...payload } });
    },

    *getMagic({ payload }, { call, put }) {
      const magicInfo = yield call(getBaseInfo);
      yield put({ type: 'save', payload: { magicInfo: magicInfo?.[0] } });
    },
    /**
     * 获取所有的有关 免费期限，个人付费，机构付费的有效期
     */
    *getAllpermission({ payload }, { call, put }) {
      try {
        if (!payload?.orgId || payload?.orgId == 0) {
          const expire = {
            个人付费: {
              remaining:
                moment(payload.pay_time, 'YYYY-MM-DD').diff(moment().format('YYYY-MM-DD'), 'days') +
                1,
              deadline: payload.pay_time,
            },
            免费试用: {
              remaining:
                moment(payload.expire_time, 'YYYY-MM-DD').diff(
                  moment().format('YYYY-MM-DD'),
                  'days',
                ) + 1,
              deadline: payload.expire_time,
            },
            机构付费: { remaining: 0, deadline: 0 },
          };
          return {
            ...expire,
            currentInfo:
              expire.个人付费.remaining > 0
                ? {
                    type: '个人付费',
                    remaining: expire?.个人付费?.remaining,
                    deadline: expire?.个人付费?.deadline,
                  }
                : {
                    type: '免费试用',
                    remaining: expire?.免费试用?.remaining,
                    deadline: expire?.免费试用?.deadline,
                  },
          };
        }
        const orgInfo = yield call(getOrgByID, payload?.orgId);
        const result = permissionLeftDetail(
          payload.expire_time,
          payload.pay_time,
          orgInfo?.expire_time,
          payload.is_bind_org,
        );

        const currentInfo =
          payload.is_bind_org == 1 && result?.机构付费?.remaining > 0
            ? {
                type: '机构付费',
                remaining: result?.机构付费?.remaining,
                deadline: result?.机构付费?.deadline,
              }
            : result?.个人付费.remaining > 0
            ? {
                type: '个人付费',
                remaining: result?.个人付费?.remaining,
                deadline: result?.个人付费?.deadline,
              }
            : {
                type: '免费试用',
                remaining: result?.免费试用?.remaining,
                deadline: result?.免费试用?.deadline,
              };

        return { ...result, currentInfo };
      } catch (error) {
        return Promise.reject({});
      }
    },
  },

  reducers: {
    updateState(state: any, { res }: any) {
      // 更新state
      try {
        const user = res?.userInfo;
        if (user?.userId) {
          setUser({
            ...user,
            id: user.userId,
            username: user.name || user.fname + ' ' + user.lname,
            ip_address: '{{auto}}',
            email: user.email,
          });
        }
      } catch (error) {
        console.log('error user add ');
      }
      return {
        ...state,
        ...res,
      };
    },

    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};

export default AuthModel;
